.input {
  background-color: white;
  border: 1px solid var(--mantine-color-primary-1);
}

.form {
  overflow-y: scroll;
  height: 90%;
}

.formBody {
  max-height: 90%;
  overflow-y: scroll;
}

.certificateButton {
  &[data-disabled="true"] {
    background-color: var(--mantine-color-gray-1);
    color: var(--mantine-color-gray-6);
    border: none !important;
  }
}
